import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import am4themes_amchartsdark from "@amcharts/amcharts4/themes/amchartsdark";
am4core.useTheme(am4themes_amchartsdark);

export default class HorizontalBarChartSeries extends Component {
  state = { visible: false, items: [] };

  componentDidMount() {
    am4core.options.commercialLicense = true;
    const { id, data, category, categoryText, values, valueText, query } =
      this.props;
    let chart = am4core.create(id, am4charts.XYChart);

    chart.data = data;

    // Legend
    chart.legend = new am4charts.Legend();
    chart.legend.position = "bottom";
    chart.legend.paddingTop = 8;
    // chart.legend.useDefaultMarker = true;
    chart.legend.fontSize = 11;
    let markerTemplate = chart.legend.markers.template;
    markerTemplate.width = 11;
    markerTemplate.height = 11;
    let marker = chart.legend.markers.template.children.getIndex(0);
    marker.cornerRadius(11, 11, 11, 11);

    // Create axes
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = category;
    if (categoryText) {
      categoryAxis.title.text = categoryText;
    }
    categoryAxis.renderer.grid.template.location = 1;
    categoryAxis.renderer.minGridDistance = 10;

    // label
    let label = categoryAxis.renderer.labels.template;
    label.truncate = true;
    label.wrap = true;
    label.fontSize = 12;
    label.maxWidth = 150;
    // label.align = "left";
    label.hideOversized = true;

    chart.events.on("datavalidated", function (ev) {
      let chart = ev.target;
      let categoryAxis = chart.yAxes.getIndex(0);
      let adjustHeight = chart.data.length * 40 - categoryAxis.pixelHeight;
      let targetHeight = chart.pixelHeight + adjustHeight;
      chart.svgContainer.htmlElement.style.height = targetHeight + "px";
    });

    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    if (valueText) {
      valueAxis.title.text = valueText;
    }

    // Create series
    values.forEach((value, i) => {
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = value.key;
      series.dataFields.categoryY = category;
      series.name = value.title;
      series.tooltipText = "{name}: [bold]{valueX}[/]";

      // click
      series.columns.template.events.on("hit", (ev) => {
        const category = ev.target.dataItem.categoryY;
        if (Object.keys(query).length) this.loadDetails(category);
      });

      // bullets
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueX}";
      labelBullet.dx = 20;
      labelBullet.label.fill = am4core.color("#98a4b9");
      labelBullet.fontSize = 10;
      labelBullet.label.truncate = false;
      labelBullet.label.hideOversized = false;

      // colors
      if (value.color) {
        series.columns.template.stroke = am4core.color(value.color);
        series.columns.template.fill = am4core.color(value.color);
      }
    });

    // Add cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "zoomY";
    chart.cursor.lineY.disabled = true;
    this.chart = chart;
  }

  loadDetails = async (categoryY) => {
    const { category, cubejsApi, query } = this.props;
    const resultSet = await cubejsApi.load({
      ...query,
      filters: [
        {
          dimension: category,
          operator: "equals",
          values: [categoryY],
        },
      ],
    });
    const items = resultSet.rawData();
    this.setState({
      visible: true,
      items,
    });
  };

  hideDetails = (e) => {
    this.setState({
      visible: false,
    });
  };

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  render() {
    const { visible, items } = this.state;
    const { id, height, renderDetail } = this.props;
    return (
      <div>
        <div style={{ position: "relative", height, overflowY: "auto" }}>
          <div id={id} style={{ width: "100%", height }} />
        </div>
        <Modal
          title="Детализация"
          visible={visible}
          onCancel={this.hideDetails}
          width="96%"
          footer={null}
          bodyStyle={{
            height: "88vh",
            overflowY: "auto",
          }}
          centered
        >
          {renderDetail(items)}
        </Modal>
      </div>
    );
  }
}

HorizontalBarChartSeries.defaultProps = {
  category: "category",
  height: "480px",
  cubejsApi: null,
  query: {},
  renderDetail: () => {},
};

HorizontalBarChartSeries.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  category: PropTypes.string,
  categoryText: PropTypes.string,
  values: PropTypes.array,
  valueText: PropTypes.string,
  height: PropTypes.number,
  cubejsApi: PropTypes.object,
  query: PropTypes.object,
  renderDetail: PropTypes.func,
};
